import { render } from "./Footer.vue?vue&type=template&id=00296256&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=00296256&scoped=true&lang=css"

import exportComponent from "/Users/tony.waddington/Desktop/Vue/gi-video-partners-2/v2-remove_noCodeAPI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00296256"]])

export default __exports__